import { Alert } from "antd"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"

import { generateDocumentTitle } from "../../../constants/document-title.ts"
import { useAppSelector } from "../../../hooks/use-app-selector.ts"
import {
  selectActiveBranchId,
  selectCompanyIsMultiBranch
} from "../../Branches/redux/branches.slice.ts"
import { AutomationSubTabs } from "../components/common/AutomationSubTabs.tsx"
import { StatusAutomationSettingsCard } from "../components/settings-configuration/status-automation/StatusAutomationSettingsCard.tsx"

export default function SettingsStatusAutomationPage() {
  const { t } = useTranslation()
  const isMultiBranch = useAppSelector(selectCompanyIsMultiBranch)
  const activeBranchId = useAppSelector(selectActiveBranchId)
  const isBranchScope = isMultiBranch && !!activeBranchId

  useEffect(() => {
    generateDocumentTitle("Settings Status Automation")
  }, [])

  return (
    <div className="flex-1 flex flex-col gap-3 w-full">
      <AutomationSubTabs />
      {isBranchScope && (
        <Alert
          type="info"
          showIcon
          message={t("settingsConfiguration.statusAutomation.companyWide")}
        />
      )}
      <StatusAutomationSettingsCard />
    </div>
  )
}
